import { render } from "./AlertSuccess.vue?vue&type=template&id=5f87ca3e"
import script from "./AlertSuccess.vue?vue&type=script&lang=js"
export * from "./AlertSuccess.vue?vue&type=script&lang=js"
script.render = render

export default script